import svg from './row-svg/kozikaza-v2.svg';
import { FixMe } from '@greenkub-fronts/shared/interface';

export function KozikazaV2Icon(props: FixMe) {
  return <img {...props} src={svg} alt="svg" />;
}

export default KozikazaV2Icon;
